import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetClassAttendanceStatusParams {
  _id: string;
  isPresent: boolean;
  statusDetail: string;
}

export const getClassAttendanceStatusAPI = async () => {
  const response = await baseAPI.get<Array<GetClassAttendanceStatusParams>>(
    `/attendance`,
    {},
  );
  return response.data;
};

export const useGetClassAttendanceStatus = () => {
  return useQuery({
    queryKey: [KEYS.ATTENDANCE_STATUS],
    queryFn: () => getClassAttendanceStatusAPI(),
    staleTime: 1000 * 60 * 5,
  });
};
